module.exports = __webpack_public_path__ + "img/dataDrivenCreative.0458a3e9.gif";